// extracted by mini-css-extract-plugin
export default {"Read":"src-Read-Read-module__Read--QRBwl"};